<!-- Option C design: centered card on soft brand-tinted background. Functional elements/bindings unchanged. -->
<div class="FP_Outer">
    <div class="MainOuter FP_Center">
        <div class="FP_Card">
            <div class="FP_Header">
                <div class="FP_Logo">
                    <img src="../../../assets/images/Login_Logo.svg" alt="InCred Markets">
                </div>
                <svg class="FP_WaveBottom" viewBox="0 0 430 40" preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path fill="#ffffff" d="M0 18 C90 40 150 0 215 14 C285 30 350 32 430 12 L430 40 L0 40 Z"></path>
                </svg>
            </div>

            <!-- Step 1: Enter User ID -->
            <div *ngIf='IsChangePass' class="FP_Step">
                <div class="FP_Icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#FF6200" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="10" rx="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        <circle cx="12" cy="16" r="1.4" fill="#FF6200" stroke="none"></circle>
                    </svg>
                </div>
                <div class="OtpVerificationTitle SetNewPasswordtitle">Please enter User ID</div>
                <form autocomplete="off" [formGroup]="ChangePassForm" (ngSubmit)="onSubmitChangePass(0)" class="LoginForm">
                    <div class="InputBoxOuter PANInputBox">
                        <input type="text" id="userid" #userid formControlName="VERIFICATION_ID"
                            oninput="this.value = this.value.toUpperCase()"
                            class="form-control CommonTextBox LoginFormInputTextBox"
                            [ngClass]="{ 'is-invalid': ChangePassSubmitted && r.VERIFICATION_ID.errors }"
                            placeholder="Enter User ID" maxlength="10" />

                        <div *ngIf="ChangePassSubmitted && r.VERIFICATION_ID.errors" class="invalid-feedback">
                            <div *ngIf="r.VERIFICATION_ID.errors.required">Please Enter Your User ID</div>
                        </div>
                    </div>
                    <div class="SubmitMarginTop text-center">
                        <button class="CommonSubmitButton">Continue</button>
                    </div>
                </form>
                <div class="FP_BackLink CursorPointer" routerLink='/login-incred' routerLinkActive='active'>
                    <svg class="BackArrowSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                    Back to login
                </div>
            </div>

            <!-- Step 2: OTP Verification -->
            <div class="FP_Step" *ngIf="IsOTPVerify">
                <div class="FP_Icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#FF6200" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="10" rx="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        <circle cx="12" cy="16" r="1.4" fill="#FF6200" stroke="none"></circle>
                    </svg>
                </div>
                <div class="OtpVerificationTitle">OTP Verification</div>
                <p class="OtpVerificationParagraph">Please enter the OTP sent to your registered mobile number.</p>
                <form autocomplete="off" [formGroup]="OTPForm" (ngSubmit)="onOTPSubmit()" class="LoginForm">
                    <div class="InputBoxOuter">
                        <label for="Otp" class="lable OtpText">
                            Enter 6 digit OTP
                        </label>
                        <ng-otp-input formControlName="OTP" id="OTPBox" (onInputChange)="onOtpChange($event)"
                            #ngOtpInput [config]="config" inputmode="numeric" pattern="[0-9]*">
                        </ng-otp-input>
                        <div *ngIf="OTPFormSubmitted && o.OTP.errors" class="invalid-feedback">
                            <div *ngIf="o.OTP.errors.required">Please enter OTP.</div>
                            <div *ngIf="o.OTP.errors.pattern">Please enter valid OTP</div>
                        </div>
                    </div>
                    <div class="SubmitMarginTop d-flex justify-content-center">
                        <button class="CommonSubmitButton">Verify</button>
                    </div>
                </form>
                <div class="FP_BackLink CursorPointer" (click)='ActiveChangePassTab()'>
                    <svg class="BackArrowSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                    Back
                </div>
            </div>

            <!-- Step 3: Set New Password -->
            <div class="FP_Step" *ngIf='IsNewPass'>
                <div class="FP_Icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#FF6200" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="10" rx="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        <circle cx="12" cy="16" r="1.4" fill="#FF6200" stroke="none"></circle>
                    </svg>
                </div>
                <div class="OtpVerificationTitle SetNewPasswordtitle">Reset Password</div>
                <p class="OtpVerificationParagraph SetNewPasswordParagraph">Please enter a new password</p>
                <form autocomplete="off" [formGroup]="SetPassForm" (ngSubmit)="SetPassFormSubmit()" class="LoginForm">
                    <div class="InputBoxOuter">
                        <label for="NewPassword" class="label">
                            Reset Password
                        </label>
                        <show-hide-password btnStyle="" [btnOutline]="false" class="">
                            <input type="password" formControlName="Password"
                                class="form-control CommonTextBox LoginFormInputTextBox"
                                [ngClass]="{ 'is-invalid': SetPassFormSubmitted && p.Password.errors }"
                                placeholder="New Password" maxlength="20" #newpassword />
                        </show-hide-password>

                        <div class="PasswordValidationsBox invalid-feedback"
                            *ngIf="SetPassFormSubmitted && p.Password.errors">
                            <div class="FirstValidation PasswordValidation">
                                <div class="FirstValidationImg">
                                    <img src="../../assets/images/IIFL_New_Icons/circle.svg" alt="">
                                </div>
                                <div class="FirstValidationText">8 - 12 Characters</div>
                            </div>
                            <div class="SecondValidation PasswordValidation ">
                                <div class="FirstValidationImg">
                                    <img src="../../assets/images/IIFL_New_Icons/circle.svg" alt="">
                                </div>
                                <div class="FirstValidationText">Atleast 1 Number</div>
                            </div>
                            <div class="ThirdValidation PasswordValidation ">
                                <div class="FirstValidationImg">
                                    <img src="../../assets/images/IIFL_New_Icons/circle.svg" alt="">
                                </div>
                                <div class="FirstValidationText">Atleast 1 special character</div>
                            </div>
                            <div class="FourthValidation PasswordValidation ">
                                <div class="FirstValidationImg">
                                    <img src="../../assets/images/IIFL_New_Icons/circle.svg" alt="">
                                </div>
                                <div class="FirstValidationText">Do not have space & dots</div>
                            </div>
                            <div class="FifthValidation PasswordValidation ">
                                <div class="FirstValidationImg">
                                    <img src="../../assets/images/IIFL_New_Icons/circle.svg" alt="">
                                </div>
                                <div class="FirstValidationText">Can not contain special character (')</div>
                            </div>
                            <div class="SixthValidation PasswordValidation ">
                                <div class="FirstValidationImg">
                                    <img src="../../assets/images/IIFL_New_Icons/circle.svg" alt="">
                                </div>
                                <div class="FirstValidationText">Can not be identical to old password & Client Id</div>
                            </div>
                        </div>
                    </div>
                    <div class="InputBoxOuter ConfirmPasswordBox">
                        <label for="ConfirmPassword" class="lable">
                            Confirm Password
                        </label>
                        <show-hide-password btnStyle="" [btnOutline]="false">
                            <input type="password" formControlName="NEW_PASS"
                                class="form-control CommonTextBox LoginFormInputTextBox"
                                [ngClass]="{ 'is-invalid': SetPassFormSubmitted && p.NEW_PASS.errors }"
                                placeholder="Confirm Password" maxlength="20" />
                            <div *ngIf="SetPassFormSubmitted && p.NEW_PASS.errors" class="invalid-feedback">
                                <div *ngIf="p.NEW_PASS.errors.required">Confirm password is required</div>
                                <div *ngIf="p.NEW_PASS.errors.mustMatch;">Password must match</div>
                            </div>
                            <div class="Match_Validation" *ngIf!="p.NEW_PASS.errors">
                                <img src="../../assets/images/IIFL_New_Icons/GreenValidationIcon.svg" alt="">Password match
                            </div>
                        </show-hide-password>
                    </div>
                    <div class="SubmitMarginTop d-flex justify-content-center">
                        <button class="CommonSubmitButton">Continue</button>
                    </div>
                </form>
                <div class="FP_BackLink CursorPointer" (click)="ActiveOTPTab()">
                    <svg class="BackArrowSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                    Back
                </div>
            </div>

            <!-- Password set successfully greeting (hidden) -->
            <div class="PasswordSetSuccessfullyGreetingBox d-none">
                <div class="row ">
                    <div class="col InputBoxOuter">

                        <div class=" UserInputContainer">
                            <!-- PasswordSetSuccessfully Greeting box start -->
                            <div class="">
                                <div class="GreetingBox">

                                    <div class="GreetingImg">
                                        <img src="../../assets/images/IIFL_New_Icons/PasswordSetSuccessIcon.svg" alt="">
                                    </div>

                                    <div class="GreetingText">
                                        Your password <br> has been set successfully!
                                    </div>
                                </div>
                            </div>
                            <!-- PasswordSetSuccessfully Greeting box end -->
                        </div>
                    </div>
                </div>

                <!-- PasswordSetSuccessfully Greeting Login button start-->
                <div class="text-center w-100 mb-5">
                    <button class="CommonSubmitButton PasswordSetSuccessGreetingBtn ">Login</button>
                </div>
                <!-- PasswordSetSuccessfully Greeting Login button end-->
            </div>

        </div>
    </div>
</div>
<app-footer></app-footer>
<!-- The Modal -->
<div class="modal" id="SuccessSetPassAlertModal">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content AlertModalContentCls">
            <!-- Modal Header -->
            <div class="modal-header AlertModalHeader">Important Message
                <button type="button" class="close" routerLink='/login-incred' routerLinkActive='active'
                    (click)="HideModal()">&times;</button>
            </div>
            <!-- Modal body -->
            <div id="SuccessAlertModalContent" class="modal-body AlertModalBody">
                Your password has been reset successfully.
            </div>
            <div class="modal-footer AlertModalFooter">
                <button class="CursorPointer" routerLink='/login-incred' routerLinkActive='active'
                    (click)="HideModal()">Login</button>
            </div>
        </div>
    </div>
</div>
<div class="modal" id="AlertModalOTPVerification" data-backdrop="static" data-keyboard="false" appDisabledRightClick>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content AlertModalContentCls">
            <div class="modal-header AlertModalHeader">OTP Verification <button type="button" class="close"
                    data-dismiss="modal" aria-label="Close" (click)="CloseMainModal()">
                    <span aria-hidden="true">&times;</span>
                </button></div>
            <div class="FP_OtpIllus">
                <svg viewBox="0 0 220 170" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <defs>
                        <linearGradient id="otpOrange" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stop-color="#FF6200"></stop>
                            <stop offset="1" stop-color="#FF8C0F"></stop>
                        </linearGradient>
                    </defs>
                    <circle cx="110" cy="98" r="58" fill="#FFF1E6"></circle>
                    <circle cx="180" cy="44" r="3.5" fill="#FFD500"></circle>
                    <circle cx="46" cy="120" r="3" fill="#00A99D"></circle>
                    <g stroke="#00A99D" stroke-width="3" stroke-linecap="round">
                        <path d="M40 54h11M45.5 48.5v11"></path>
                    </g>
                    <g stroke="#FF9A4D" stroke-width="3" stroke-linecap="round">
                        <path d="M182 110h9M186.5 105.5v9"></path>
                    </g>
                    <!-- envelope -->
                    <rect x="54" y="80" width="112" height="70" rx="10" fill="#fff" stroke="url(#otpOrange)" stroke-width="3"></rect>
                    <path d="M58 86L110 122L162 86" stroke="url(#otpOrange)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                    <!-- shield with padlock -->
                    <path d="M110 18L135 29L135 48C135 60 124 67 110 72C96 67 85 60 85 48L85 29Z" fill="url(#otpOrange)"></path>
                    <rect x="99" y="40" width="22" height="16" rx="3" fill="#fff"></rect>
                    <path d="M103 40v-4a7 7 0 0 1 14 0v4" stroke="#fff" stroke-width="3" fill="none"></path>
                    <circle cx="110" cy="48" r="2.4" fill="url(#otpOrange)"></circle>
                </svg>
            </div>
            <p class="OtpVerificationParagraph my-3 mx-2">Please enter the OTP sent to your
                registered Mobile <br> Number <span id="sendedOTPMobileNumber"></span> and Email Id <br><span
                    id="sendedOTPEmailId"></span></p>
            <form autocomplete="off" [formGroup]="CodifyOTPForm" (ngSubmit)="onSubmitVerifyOTP()">
                <div class="modal-body AlertModalBody">
                    <div class="row justify-content-center">
                        <div class="col-lg-8">
                            <label for="Otp" class="lable OtpText">
                                Enter 6 digit OTP
                            </label>
                            <div>
                                <ng-otp-input id="OTPBox" #ngCodifyOtpInput [config]="config" inputmode="numeric" pattern="[0-9]*" (onInputChange)="onOtpChange($event)">
                                </ng-otp-input>
                                <div *ngIf="OTPFormSubmitted && codifyOTPForm.OTP.errors" class="text-danger">
                                    <div *ngIf="codifyOTPForm.OTP.errors.required">Please enter OTP</div>
                                    <div *ngIf="codifyOTPForm.OTP.errors.minlength"> OTP must be 6 digits</div>
                                </div>
                            </div>
                            <div class="ResendText" [ngClass]='IsShowInvalidOTPMsg ? "d-block" : "d-none"'>
                                <div class="text-danger text-center">You have enter invalid OTP Code</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer AlertModalFooter">
                    <button type="submit" class="CommonSubmitButton CursorPointer VerifyOtpBtn"
                        [disabled]="!CodifyOTPForm.valid">Verify</button>
                </div>
            </form>
        </div>
    </div>
</div>
